import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { logUtil } from 'packages/src'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'

export default function ItemEmbed ({
  source,
  isBig,
  onClick
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  logUtil('ItemEmbed').debug(`source=${source}`)
  let width
  if (isSmallScreen) {
    width = '100%'
  } else {
    width = isBig ? '47.44em' : '35.55em'
  }

  return (
    <div
      style={{
        maxWidth: '100%',
        position: 'relative',
        width
      }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: source
        }}
        onClick={handleClick}
        style={{
          width: '100%',
          height: '100%'
        }}
      />
    </div>
  )
}
